/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '0.1.0';
export const PublishedData = {
    type: 'object',
    properties: {
        standardProducts: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    entityHashes: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    }
                },
                required: [
                    'entityHashes'
                ],
                additionalProperties: false
            }
        },
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        type: 'string'
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    type: 'string'
                                },
                                description: {
                                    type: 'string'
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    type: 'string'
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        }
    },
    additionalProperties: false,
    required: []
};
export const SessionData = {
    type: 'object',
    properties: {}
};
export const FrontendData = {};
export const FinalizeData = {};
export const PrefetchedFinalizeData = {};
export const FinalizeResult = {
    type: 'object',
    properties: {
        clientGeneratedImageLink: {
            type: 'string'
        },
        shopifyProduct: {
            type: 'object',
            properties: {
                success: {
                    type: 'boolean'
                },
                productId: {
                    type: 'number'
                },
                productTitle: {
                    type: 'string'
                },
                productUrl: {
                    type: 'string'
                },
                productVariantId: {
                    type: 'number'
                },
                sku: {
                    type: 'string'
                },
                price: {
                    type: 'string'
                },
                message: {
                    type: 'string'
                },
                error: {
                    type: 'string'
                }
            },
            additionalProperties: false
        }
    },
    required: [],
    additionalProperties: false
};
export const CallbackData = {
    type: 'object',
    properties: {
        customProduct: {
            type: 'object',
            properties: {
                title: {
                    type: 'string'
                },
                description: {
                    type: 'string'
                },
                price: {
                    type: 'number'
                }
            },
            required: [
                'title',
                'description',
                'price'
            ],
            additionalProperties: false
        }
    },
    required: [
        'customProduct'
    ],
    additionalProperties: false
};
export const BackendData = undefined;
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Initial',
        'FinalizeCart',
        'FinalizeWishlist'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        'Default',
        'FocusOnLiner'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Default'
    ]
});
export const ExportState = new EnumReflection('ExportState', {
    enum: [
        'Default'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'PresetCategories',
        'Presets',
        'StandardProducts'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});
export const $dataSpec = {
    custom: {},
    swatchOptions: []
};

//# sourceMappingURL=application-types.js.map